import React from 'react';
export function GuaranteeSection() {
  return <section className="py-6 px-4 bg-blue-50" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        <div className="bg-white p-5 rounded-lg shadow-2xl border-4 border-blue-500" data-id="element-169">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-4 text-blue-600" data-id="element-170">
            🛡️ GARANTÍA TOTAL
          </h2>

          <div className="text-center mb-4" data-id="element-171">
            <p className="text-2xl mb-2" data-id="element-172">Prueba el sistema por 7 días.</p>
            <p className="text-2xl mb-2" data-id="element-173">Si no te sirve…</p>
            <p className="text-3xl font-bold text-green-600 mb-2" data-id="element-174">
              👉 Te devolvemos el dinero.
            </p>
            <p className="text-xl font-bold" data-id="element-175">Sin preguntas.</p>
          </div>

          <div className="bg-blue-100 p-4 rounded-lg" data-id="element-176">
            <p className="text-lg text-center" data-id="element-177">
              Tienes{' '}
              <span className="font-bold text-2xl text-blue-600" data-id="element-178">
                CERO RIESGO
              </span>
              . Si el programa no cumple tus expectativas, recuperas tu
              inversión completa.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
export default GuaranteeSection;